import { render, staticRenderFns } from "./GruposGrade.vue?vue&type=template&id=e333bb34&scoped=true"
import script from "./GruposGrade.vue?vue&type=script&lang=js"
export * from "./GruposGrade.vue?vue&type=script&lang=js"
import style0 from "./GruposGrade.vue?vue&type=style&index=0&id=e333bb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e333bb34",
  null
  
)

export default component.exports